import moment from 'moment'
import { isString } from 'lodash'

import { moment2str, str2moment, randstr, timestamp } from '../../lib/Tools'
import createDuck from '../lib/MetagnosticDuck'
import ActionTypes from '../actions/ActionTypes.js'
import { getTrip, getTrips } from '../lib/APIClient'
import { createRoute, cloneRoute } from '../ducks/routes'

import { getStatusValue } from '../trips/TripStatus.js'

const thisYear = (new Date()).getFullYear()

/**
 *
 */

export const getEmptyPayment = () => ({ 
  key: null, 
  eur: 0, 
  yuan: 0, 
  sentDate: moment().format("YYYY/MM/DD"), 
  receivedDate: null, 
  isReceived: null, 
  receivedEur: 0, 
  paymentMethod: null, 
  comment: "" 
})

export const emptyTrip = {
  _id: null,
  creation: null, 
  tasks: {
    triggeredPlans: {
      // planId: { planId, triggerDate }
    } 
  }, 
  settings: {
    fontSize: 16, 
    columnsPerPage: 3, 
    columnSize: 32,
    proposalIncludesPrice: false, 
  }, 
  notes: [], 
  
  name: "", 
  realName: "",
  officialName: "",
  wechat: "",
  email: "", 
  origin: "unknown", 
  status: getStatusValue("new"),
  encargado: null, 
  startDate: null, 
  endDate: null,
  returnDescription: "", 
  reservationDone: {}, 
  reservationNotes: {}, 
  preferences: [],
  note: "",  // TODO rename this
  comment: "", 
  channelComment: "", 
  travelReason: "leisure",
  travelReasonComment: "",
  pGestion: 15, 
  rounding: 10, 
  onlyRoundUp: false, 
  useForcedPrice: false, 
  
  // forcedPrice: 1, 
  forcedPriceEur: 0, 
  forcedPriceYuan: 0, 
  conversionTime: null, 
  conversionRate: null, 

  payments: [
    // { key, eur, yuan, ?actualEur, ?lostToFees, date, comment }
  ],

  routes: [], 
  mainRoute: null, 

  hasVisa: false, 
  clientClass: null, // DEPRECATED
  clientChannel: null, 

  reservations: {}, 
  exemptMoney: 0, 
  otherExempt: 0, 

  receiptValue: "",
  receiptDate: "", 
  receiptNumber: "", 
  receiptYear: thisYear,

  // #TODO may be join this up
  commission: 0,
  commissions: [], // [{ name: "comisión cabify", value: 6,21 }]

  appEnabled: false, 
  appNotifications: { 
    // additional notifications created by the agent
    custom: [
      // { enabled: false, name: "", title: "", day: "", time: "" }
    ], 
    // dict with item keys to en/disable notification 
    enabledItemKeys: {   
      // { enabled: true, title: "" }
    }, 
  }, 
  pushSubscriptions: [], 

  tickets: {},
  feedback: {},

  tags: {},

  people: {
    data: {
      firstPerson: { key: "firstPerson", name: "", passport: "", age: null}
    },
    couples: {}
  }
}

const getEmptyNote = () => ({ text: "", creation: moment().format("YYYY/MM/DD") })

const customRehydrate = trip => ({
  ...emptyTrip, 
  ...trip, 
  settings: { ...emptyTrip.settings, ...trip.settings }, 
  people: { ...emptyTrip.people, ...trip.people },
  status: isString(trip.status) ? 10 : trip.status, 

  creation: str2moment(trip.creation || "1990/01/01 00:00:00"), 
  modification: str2moment(trip.modification || trip.creation || "1990/01/01 00:00:00"), 
  startDate: trip.startDate ? moment2str(str2moment(trip.startDate)) : trip.startDate, // sorry
  endDate: trip.endDate ? moment2str(str2moment(trip.endDate)) : trip.endDate,         // really sorry

  adults: -333,
  kids: -333
})

/**
 * ACTIONS
 */

// creation
const _createTrip = (initials, cb) => (dispatch, getState) => {
  const id = randstr(16)

  dispatch(createRoute({}, route => {
    console.log(`created a route, got id ${route}, gonna use it for trip ${id}`)
    if (cb) cb(id)
    dispatch({
      type: ActionTypes.CREATE_ONE_TRIPS,
      id, 
      payload: {
        ...initials, 
        encargado: getState().loginData.username, 
        routes: [route], 
        mainRoute: route, 
      }
    })
  }))
}

// notes

const _updateNotes = action => dispatch => {
  dispatch({ type: ActionTypes.UPDATE_TRIP_NOTES, ...action })

  dispatch((dispatch2, getState) => dispatch2({ 
    type: ActionTypes.UPDATED_ONE_TRIPS, 
    id: action.id, 
    payload: { 
      notes: getState().trips[action.id].notes 
    } 
  }))
}

const _createTripNote = (id, initials, idCallback) => {
  const noteId = randstr()
  if (idCallback) idCallback(noteId)

  return _updateNotes({ 
    id, noteId, subtype: "CREATE", payload: initials, 
  })
}

const _editTripNote = (id, noteId, changes) => (_updateNotes({ id, subtype: "EDIT", noteId, payload: changes }))

const _removeTripNote = (id, noteId) => (_updateNotes({ id, subtype: "REMOVE", noteId, }))

// routes

const _addNewRoute = id => (dispatch, getState) => {
  dispatch(
    createRoute(
      {}, 
      rid => dispatch({ 
        id, 
        type: ActionTypes.UPDATE_ONE_TRIPS, 
        payload: { routes: getState().trips[id].routes.concat(rid) }
      })))
}

const _addClonedRoute = (id, cloned) => (dispatch, getState) => {
  console.log("addClonedRoute...")
  dispatch(
    cloneRoute(
      cloned, 
      clone => dispatch({
        id, 
        type: ActionTypes.UPDATE_ONE_TRIPS, 
        payload: { routes: getState().trips[id].routes.concat(clone) }
      })))
}
    
const customActions = {
  createDoc: _createTrip, 
  createTripNote: _createTripNote, 
  editTripNote: _editTripNote, 
  removeTripNote: _removeTripNote, 
  addNewRoute: _addNewRoute, 
  addClonedRoute: _addClonedRoute
}

/**
 * REDUCER
 */

const updateTripNotes = (state, action) => {
  const notes = state.notes
  const {payload} = action

  if (action.subtype === "CREATE") {
    return {
      ...state, 
      notes: [
        ...notes, 
        {
          ...getEmptyNote(),
          id: action.noteId,
          ...payload
        }
      ]
    }
  }
  else if (action.subtype === "EDIT") {
    return {
      ...state, 
      notes: notes.map(note => (
        note.id === action.noteId ? { ...note, ...payload, modification: timestamp() } : note
      ))
    }
  }
  else if (action.subtype === "REMOVE") {
    return {
      ...state, 
      notes: notes.filter(note => note.id !== action.noteId)
    }
  }
  else return state
}

const customReducers = {
  UPDATE_TRIP_NOTES: (state, action) => { 
    const target = state[action.id]
    if (!target) return state
    else return { 
      ...state, 
      [target._id]: updateTripNotes(target, action) 
    }
  }
}

/**
 * 
 */

const duck = createDuck("TRIPS", getTrip, getTrips, customActions, emptyTrip, customReducers, { customRehydrate })

export const createTrip = duck.actions.createDoc
export const receiveTrips = duck.actions.receiveCollection
export const receiveTrip = duck.actions.receiveDoc
export const removeTrip = duck.actions.removeDoc
export const fetchTrips = duck.actions.fetchCollection
export const updateTrip = duck.actions.updateDoc

export const createTripNote = duck.actions.createTripNote
export const editTripNote = duck.actions.editTripNote
export const removeTripNote = duck.actions.removeTripNote
export const addNewRoute = duck.actions.addNewRoute
export const addClonedRoute = duck.actions.addClonedRoute

export default duck
